import React, { useState } from 'react';

const DataDebugger = ({ fieldName, value, collection = 'users', subCollection = null, isVisible = false }) => {
  const [showDebug, setShowDebug] = useState(false);
  
  // Only show in development mode
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  const getCollectionPath = () => {
    if (subCollection) {
      return `${collection} > ${subCollection}`;
    }
    return collection;
  };

  const getValueDisplay = () => {
    if (value === null || value === undefined) {
      return 'null';
    }
    if (typeof value === 'object') {
      return JSON.stringify(value, null, 2);
    }
    if (typeof value === 'boolean') {
      return value ? 'true' : 'false';
    }
    return String(value);
  };

  return (
    <div className="mt-2 p-2 bg-gray-100 dark:bg-gray-800 rounded border border-gray-300 dark:border-gray-600">
      <button
        onClick={() => setShowDebug(!showDebug)}
        className="text-xs text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 font-mono"
      >
        🔍 Debug: {fieldName} {showDebug ? '▼' : '▶'}
      </button>
      
      {showDebug && (
        <div className="mt-2 space-y-1 text-xs font-mono">
          <div className="text-gray-600 dark:text-gray-400">
            <strong>Field:</strong> {fieldName}
          </div>
          <div className="text-gray-600 dark:text-gray-400">
            <strong>Collection:</strong> {getCollectionPath()}
          </div>
          <div className="text-gray-600 dark:text-gray-400">
            <strong>Value:</strong>
          </div>
          <div className="bg-gray-200 dark:bg-gray-700 p-2 rounded text-gray-800 dark:text-gray-200 max-h-20 overflow-auto">
            {getValueDisplay()}
          </div>
        </div>
      )}
    </div>
  );
};

export default DataDebugger;
